<div class="min-h-screen">
  <app-block-list [blockIdList]="body"></app-block-list>
</div>
<router-outlet></router-outlet>
